export default Object.freeze({
  UploadFile: 'upload-file',
  DownloadFile: 'download-file',
});
